import React from "react";

export function CompletedFacets({ facets }) {
  if (!Array.isArray(facets) || facets.length === 0) return null;
  const statusColors = {
    covered: '#d1f5e6',
    partial: '#fff3cd',
    missing: '#f8d7da',
  };
  return (
    <div style={{
      background: '#f5f8fa',
      border: '1px solid #e3eaf2',
      borderRadius: 8,
      padding: '12px 16px',
      marginTop: 10,
      marginBottom: 4,
      boxSizing: 'border-box',
    }}>
      <div style={{ fontWeight: 600, color: '#1a3556', fontSize: 15, marginBottom: 8 }}>Completed Facets</div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
        <thead>
          <tr style={{ background: '#e3eaf2' }}>
            <th style={{ textAlign: 'left', padding: '6px 8px', color: '#1a3556' }}>Facet</th>
            <th style={{ textAlign: 'left', padding: '6px 8px', color: '#1a3556' }}>Status</th>
            <th style={{ textAlign: 'left', padding: '6px 8px', color: '#1a3556' }}>Notes</th>
            <th style={{ textAlign: 'left', padding: '6px 8px', color: '#1a3556' }}>Citations</th>
          </tr>
        </thead>
        <tbody>
          {facets.map((facet, i) => (
            <tr key={i} style={{ background: statusColors[facet.status] || '#fff' }}>
              <td style={{ padding: '6px 8px', fontWeight: 500 }}>{facet.name}</td>
              <td style={{ padding: '6px 8px', fontWeight: 500, color: '#222' }}>{facet.status.charAt(0).toUpperCase() + facet.status.slice(1)}</td>
              <td style={{ padding: '6px 8px', color: '#555' }}>{facet.notes || '-'}</td>
              <td style={{ padding: '6px 8px', color: '#007bff' }}>
                {Array.isArray(facet.citations) && facet.citations.length > 0 ? (
                  facet.citations.map((c, idx) => <span key={idx} style={{ marginRight: 8 }}>{c}</span>)
                ) : '-'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
